import { render, staticRenderFns } from "./VariantPickerPropertyButton.vue?vue&type=template&id=2f1d91e2&"
import script from "./VariantPickerPropertyButton.vue?vue&type=script&lang=js&"
export * from "./VariantPickerPropertyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports